<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Sprawy</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/messages/list">Sprawy</router-link>
        </li>
        <li class="active">
          <strong>Szczegóły</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <button
      v-if="messageObj.status !== 'close'"
      @click="closeMessage"
      class="btn btn-primary"
    >
      Zamknij sprawę
    </button>
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isDetailsOpen = !isDetailsOpen">
            <h5>Szczegóły</h5>
            <span class="ibox-toggle">
              <i :class="chevronDetailsClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div v-if="messageObj" class="ibox-content" v-show="isDetailsOpen">
              <dl class="dl-horizontal">
                <dt>Reklamacja</dt>
                <dd v-if="messageObj.complaint_reason">
                  <span class="fa fa-check text-navy"></span>
                </dd>
                <dd v-else><span class="fa fa-times text-danger"></span></dd>
                <dt>Status</dt>
                <dd>{{ messageObj.status_display }}</dd>
                <dt v-if="messageObj.competency_negotiations">
                  Negocjowane zamówienie
                </dt>
                <dd v-if="messageObj.competency_negotiations">
                  {{ messageObj.order }}
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div
            class="ibox-title"
            @click="isDescriptionOpen = !isDescriptionOpen"
          >
            <h5>Opis sprawy</h5>
            <span class="ibox-toggle">
              <i :class="chevronDescriptionClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDescriptionOpen">
              <div v-if="adminsOptions" class="form-group">
                <label class="control-label col-sm-2">
                  Osoba odpowiedzialna
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="messageObj.responsible_person"
                    mode="single"
                    placeholder="Osoba odpowiedzialna"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="adminsOptions"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.responsible_person"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.responsible_person[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Klient</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="messageObj.client"
                    mode="single"
                    placeholder="Klient"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="clientsOptions"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.client" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.client[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Rodzaj sprawy</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="messageObj.competency"
                    mode="single"
                    placeholder="Rodzaj sprawy"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="adminsReasons"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.competency"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.competency[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Powód reklamacji</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="messageObj.complaint_reason"
                    mode="single"
                    placeholder="Powód reklamacji"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :disabled="messageObj.competency !== 2"
                    :options="adminsComplaint"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.competency"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.competency[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Zamówienie</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    v-model="messageObj.order"
                    class="form-control inputClass"
                    placeholder="Zamówienie"
                    disabled="disabled"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Pozycja zamówienia</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    v-model="messageObj.order_product"
                    class="form-control inputClass"
                    placeholder="Pozycja zamówienia"
                    disabled="disabled"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/messages/list">
                    Anuluj
                  </router-link>
                  <button @click="saveEdit" class="btn btn-primary">
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="canViewMessages || canAddMessage"
          class="ibox float-e-margins"
        >
          <div
            class="ibox-title"
            @click="isConversationOpen = !isConversationOpen"
          >
            <h5>Konwersacja</h5>
            <span class="ibox-toggle">
              <i :class="chevronConversationClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isConversationOpen">
              <ol
                v-if="canViewMessages && messageObj?.conversation_messages"
                class="chat"
              >
                <div class="day">21.11.2023 08:21:47</div>
                <li
                  v-for="(message, index) in messageObj.conversation_messages"
                  :key="index"
                  :class="{
                    self: message.user_is_admin,
                    other: !message.user_is_admin,
                  }"
                >
                  <div class="avatar"></div>
                  <div class="msg">
                    <p>{{ message.content }}</p>
                    <div
                      v-for="(file, index) in message.message_files"
                      :key="index"
                    >
                      <a :href="file.file">{{ file.name }}</a>
                    </div>
                    <time>{{ message.date_added }}</time>
                    <span class="author">{{ message.user_username }}</span>
                  </div>
                </li>
              </ol>
              <div
                v-if="messageObj.status !== 'close' && canAddMessage"
                class="form-horizontal"
              >
                <textarea
                  v-model="chatMsg"
                  class="textarea"
                  placeholder="Kliknij aby zacząć pisać"
                  required
                ></textarea>
                <div v-if="errorsAdminData?.data?.content" class="has-error">
                  <span class="help-block">
                    {{ errorsAdminData.data.content[0] }}
                  </span>
                </div>
                <button
                  @click="sendChat"
                  class="btn-send"
                  :disabled="isSendingChat"
                >
                  <span v-if="isSendingChat">
                    <i class="fa fa-spinner fa-spin"></i>
                    Wysyłanie...
                  </span>
                  <span v-else>Odpowiedz</span>
                </button>
                <div class="form-group col-sm-12">
                  <label class="btn btn-info btn-file">
                    <span v-if="!files.length">Dodaj pliki</span>
                    <span v-if="files.length">Zmień pliki</span>
                    <input
                      ref="fileInput"
                      type="file"
                      multiple="true"
                      @change="onFileChange"
                      style="display: none"
                      :disabled="isSendingChat"
                    />
                  </label>
                  <button
                    v-if="files.length"
                    @click="clearFiles"
                    class="btn btn-default"
                    :disabled="isSendingChat"
                  >
                    Wyczyść
                  </button>
                </div>
                <ul class="list-group">
                  <li
                    v-for="(file, index) in files"
                    :key="index"
                    class="list-group-item"
                  >
                    <a>{{ file.name }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import { useRoute } from "vue-router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { useCookies } from "vue3-cookies";
import { hasPermission } from "../../permissions";
import { messagesPermissionsConst } from "../../constants/settingConstants";

export default {
  name: "ClientsCreate",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const { cookies } = useCookies();
    const route = useRoute();
    const countryList = ref([
      { name: "Polska", value: "PL" },
      { name: "Niemcy", value: "DE" },
    ]);

    const errorsAdminData = ref();
    const showErrors = ref(false);
    const isDetailsOpen = ref(true);
    const isDescriptionOpen = ref(true);
    const isConversationOpen = ref(true);
    const store = useStore();
    // The case itself is guarded by the route; the conversation inside it has
    // its own model permissions in the old panel.
    const canViewMessages = computed(() =>
      hasPermission(messagesPermissionsConst.view)
    );
    const canAddMessage = computed(() =>
      hasPermission(messagesPermissionsConst.add)
    );
    const clientsContactData = computed(
      () => store.getters.getClientsContactData
    );
    const adminsContactData = computed(
      () => store.getters.getAdminsContactData
    );
    const adminsReasonsData = computed(
      () => store.getters.getAdminsReasonsData
    );
    const adminsComplaintData = computed(
      () => store.getters.getAdminsComplaintData
    );
    const updateMessageData = computed(
      () => store.getters.getUpdateMessageData
    );
    const conversationData = computed(() => store.getters.getConversationData);
    const countriesData = computed(() => store.getters.getCountriesData);
    const messageData = computed(() => store.getters.getMessageData);
    const clientsOptions = ref([]);
    const adminsOptions = ref([]);
    const adminsReasons = ref([]);
    const adminsComplaint = ref([]);
    const countriesOptions = ref([]);
    const files = ref([]);
    const fileInput = ref(null);
    const isSendingChat = ref(false);
    const chatMsg = ref();
    const messageObj = ref({
      responsible_person: [],
      client: [],
      competence: [],
    });

    const create = () => {
      showErrors.value = true;
      // store.dispatch("createClient", clientObj.value);
    };

    // A new selection replaces the previous one, which is what the "Zmień
    // pliki" label promises.
    const onFileChange = (e) => {
      files.value = Array.from(e.target.files);
    };

    // The native input keeps the last selection, so it has to be cleared too -
    // otherwise picking the same file again fires no change event.
    const clearFiles = () => {
      files.value = [];
      if (fileInput.value) {
        fileInput.value.value = "";
      }
    };

    const closeMessage = () => {
      store.dispatch("updateMessage", {
        pk: route.params?.pk,
        status: "close",
        closeMessage: true,
      });
    };

    const sendChat = () => {
      if (isSendingChat.value) {
        return;
      }
      if (canAddMessage.value && chatMsg.value) {
        isSendingChat.value = true;
        store.dispatch("addConversation", {
          conversation: route.params?.pk,
          content: chatMsg.value,
          user: cookies.get("CPid"),
        });
      }
    };

    const saveEdit = () => {
      if (messageObj.value) {
        store.dispatch("updateMessage", messageObj.value);
      }
    };

    store.dispatch("getClientsContact", { pk: route.params?.pk });
    store.dispatch("getMessagesDetails", { pk: route.params?.pk });
    store.dispatch("getAdminsContact");
    store.dispatch("getAdminsReasons", { complaintReason: true });
    store.dispatch("getAdminsReasons", { complaintReason: false });
    store.dispatch("getCountriesList");

    watch(
      () => updateMessageData.value,
      function (newValue) {
        if (newValue.status === 200) {
          let content = "Dane sprawy zostały zaktualizowane!";
          if (newValue.closeMessage) {
            content = "Sprawa została zamknięta!";
          }
          router
            .push({ name: "MessagesList", path: "/messages/list" })
            .then(() => {
              store.dispatch("showToaster", {
                type: "success",
                content: content,
              });
            });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );
    watch(
      () => conversationData.value,
      async function (newValue) {
        if (newValue.status === 201) {
          // The endpoint takes a single file per request, so each one goes in
          // its own POST - and only once the message pk is known, since the
          // files are attached to the message created above.
          const filesToUpload = files.value.slice();
          const results = await Promise.allSettled(
            filesToUpload.map((file) =>
              store.dispatch("addMessageFile", {
                message: newValue.data.pk,
                file: file,
              })
            )
          );
          const failedFiles = filesToUpload.filter(
            (file, index) => results[index].status === "rejected"
          );

          clearFiles();
          if (failedFiles.length) {
            // Only the files that failed stay selected, so resending does not
            // duplicate the ones already attached to the message.
            files.value = failedFiles;
            store.dispatch("showToaster", {
              type: "error",
              content:
                "Wiadomość została wysłana, ale nie udało się przesłać " +
                failedFiles.length +
                " z " +
                filesToUpload.length +
                " plików!",
            });
          } else {
            store.dispatch("showToaster", {
              type: "success",
              content: "Wiadomość została wysłana!",
            });
          }
          chatMsg.value = "";
          store.dispatch("getMessagesDetails", { pk: route.params?.pk });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
        isSendingChat.value = false;
      }
    );

    watch(
      () => clientsContactData.value,
      function (newValue) {
        newValue.data.results?.forEach((element) => {
          clientsOptions.value.push({
            name: "[" + element.pk + "] " + element.full_name,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => adminsContactData.value,
      function (newValue) {
        newValue.data?.forEach((element) => {
          adminsOptions.value.push({
            name: "[" + element.pk + "] " + element.full_name,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => adminsReasonsData.value,
      function (newValue) {
        newValue.data?.forEach((element) => {
          adminsReasons.value.push({
            name: "[" + element.pk + "] " + element.name,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => adminsComplaintData.value,
      function (newValue) {
        newValue.data?.forEach((element) => {
          adminsComplaint.value.push({
            name: "[" + element.pk + "] " + element.name,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => countriesData.value,
      function (newValue) {
        newValue.data.data?.forEach((element) => {
          countriesOptions.value.push({
            name: element.name_pl,
            value: element.code,
          });
        });
      }
    );

    watch(
      () => messageData.value,
      function (newValue) {
        messageObj.value = newValue.data;
      }
    );

    return {
      countryList,
      errorsAdminData,
      showErrors,
      create,
      clientsOptions,
      adminsOptions,
      adminsReasons,
      adminsComplaint,
      countriesOptions,
      messageObj,
      files,
      fileInput,
      isSendingChat,
      onFileChange,
      clearFiles,
      closeMessage,
      chatMsg,
      sendChat,
      saveEdit,
      isDetailsOpen,
      isDescriptionOpen,
      isConversationOpen,
      canViewMessages,
      canAddMessage,
    };
  },
  computed: {
    chevronDetailsClass() {
      return this.isDetailsOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDescriptionClass() {
      return this.isDescriptionOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronConversationClass() {
      return this.isConversationOpen
        ? "fa fa-chevron-up"
        : "fa fa-chevron-down";
    },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
.ibox-toggle:hover {
  color: #333;
}
.btn-send {
  white-space: nowrap;
}
.btn-send[disabled] {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
